import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { useState } from "react";
import DisruptionForm from "../CampaignEdit/Forms/disruption";
import PlannedNoticeForm from "../CampaignEdit/Forms/planned";
import ServiceAlertForm from "../CampaignEdit/Forms/service";
import VolumeSliderForm from "../CampaignEdit/Forms/volume_slider";
import LightingSliderForm from "../CampaignEdit/Forms/lighting";
import { Box, CircularProgress, Icon } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import api from "services/api/campaign";
import { useAuth0 } from "@auth0/auth0-react";
import { PhotoView } from "react-photo-view";

export function CampaignPreviewToggle({ opt, campaignType, selectedOrg, viewFilter = 'folder' }) {
    const [showMedia, setShowMedia] = useState(false);

    // If it's not a form, just show the image preview normally
    if (opt.mediaType !== 'form') {
        return <CampaignContentPreview
            mediaType={opt.mediaType}
            contentId={opt.contentId}
            formData={opt.formData}
            campaignType={campaignType}
            selectedOrg={selectedOrg}
        />;
    }

    return (
        <>
            <SoftBox
                position="absolute"
                right="16px"
                top={viewFilter?.value == "individual" ? "20px" : "8px"}
                display="flex"
                alignItems="center"
                bgcolor="rgba(255,255,255,0.8)"
                borderRadius="5px"
            >
                <SoftTypography variant="caption" fontWeight="bold" sx={{ fontSize: '10px' }}>
                    {showMedia ? "SHOW FORM" : "SHOW IMAGE"}
                </SoftTypography>
                <input
                    type="checkbox"
                    checked={showMedia}
                    onChange={() => setShowMedia(!showMedia)}
                    style={{ cursor: 'pointer' }}
                />
            </SoftBox>

            {/* Content Rendering */}
            {showMedia ? (
                <CampaignImagePreview contentId={opt.contentId} selectedOrg={selectedOrg} />
            ) : (
                <CampaignContentPreview
                    mediaType="form"
                    formData={opt.formData}
                    campaignType={campaignType}
                    selectedOrg={selectedOrg}
                />
            )}
        </>
    );
};

export function CampaignContentPreview({ mediaType, contentId, formData, campaignType, selectedOrg }) {
    // 1. If it's a standard Media image
    if (mediaType === 'media' || !mediaType) {
        return <CampaignImagePreview contentId={contentId} selectedOrg={selectedOrg} />;
    }

    // 2. If it's a Form
    if (['form', 'config'].indexOf(mediaType) >= 0) {
        return (
            <SoftBox width="100%" height="fit-content" my={2}>
                {campaignType?.campaign_type === 'disruption' && (() => {
                    return <DisruptionForm preview={true} data={formData} />;
                })()}
                {campaignType.campaign_type == 'alerts_l' && (() => {
                    return <PlannedNoticeForm preview={true} data={formData} />;
                })()}
                {campaignType.campaign_type == 'service' && (() => {
                    return <ServiceAlertForm preview={true} data={formData} />;
                })()}
                {campaignType.campaign_type == 'tts' && (() => {
                    return <VolumeSliderForm preview={true} data={formData} />;
                })()}
                {campaignType.campaign_type == 'lighting' && (() => {
                    return <LightingSliderForm preview={true} data={formData} />;
                })()}
            </SoftBox>
        );
    }

    return (
        <SoftBox display="flex" justifyContent="center" alignItems="center" width="100%" sx={{ maxHeight: '280px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
            <Icon fontSize="large" color="disabled">help_outline</Icon>
        </SoftBox>
    );
};

// Sub-component for fetching the image preview
export function CampaignImagePreview({ contentId, selectedOrg }) {
    api.loadToken(useAuth0());

    const { data, isLoading, isError } = useQuery({
        queryKey: ['imagePreview', contentId, selectedOrg],
        queryFn: () => api.getContentFile(contentId),
        enabled: !!contentId,
        staleTime: 5 * 60 * 1000,
    });

    if (isLoading) {
        return (
            <SoftBox display="flex" justifyContent="center" alignItems="center" width="100%" sx={{ maxHeight: '280px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                <CircularProgress color="inherit" />
            </SoftBox>
        );
    }

    if (isError || !data?.signedUrl) {
        return (
            <SoftBox display="flex" justifyContent="center" alignItems="center" width="100%" sx={{ maxHeight: '280px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                <Icon fontSize="large" color="disabled">broken_image</Icon>
            </SoftBox>
        );
    }

    return (
        <PhotoView src={data.signedUrl}>
            <Box
                component="img"
                src={data.signedUrl}
                maxWidth="100%"
                my={2}
                sx={{
                    maxHeight: '280px',
                    objectFit: 'contain',// 'scale-down',
                    borderRadius: '5px',
                    cursor: 'pointer',

                    // '& img': {
                        transition: "box-shadow 0.3s ease-in-out",
                        border: '1px solid #ddd',
                        "&:hover": {
                            boxShadow: "0 0 15px 2px rgba(0, 0, 0, 0.3)"
                        }
                    // }
                }}
            />
        </PhotoView>
    );
};
